const RANKS = [
  "ไม่ระบุ",
  "นาย",
  "นาง",
  "นางสาว",
  "จ.ต.",
  "จ.ต.หญิง",
  "จ.ท.",
  "จ.ท.หญิง",
  "จ.อ.",
  "จ.อ.หญิง",
  "พ.อ.ต.",
  "พ.อ.ต.หญิง",
  "พ.อ.ท.",
  "พ.อ.ท.หญิง",
  "พ.อ.อ.",
  "พ.อ.อ.หญิง",
  "ร.ต.",
  "ว่าที่ ร.ต.",
  "ร.ต.หญิง",
  "ว่าที่ ร.ต.หญิง",
  "ร.ท.",
  "ว่าที่ ร.ท.",
  "ร.ท.หญิง",
  "ว่าที่ ร.ท.หญิง",
  "ร.อ.",
  "ว่าที่ ร.อ.",
  "ร.อ.หญิง",
  "ว่าที่ ร.อ.หญิง",
  "น.ต.",
  "ว่าที่ น.ต.",
  "น.ต.หญิง",
  "ว่าที่ น.ต.หญิง",
  "น.ท.",
  "ว่าที่ น.ท.",
  "น.ท.หญิง",
  "ว่าที่ น.ท.หญิง",
  "น.อ.",
  "ว่าที่ น.อ.",
  "น.อ.หญิง",
  "ว่าที่ น.อ.หญิง",
  "พล.อ.ต.",
  "พล.อ.ต.หญิง",
  "พล.อ.ท.",
  "พล.อ.ท.หญิง",
  "พล.อ.อ.",
  "พล.อ.อ.หญิง",
];

export default RANKS;